import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';
// Assuming convertJsonToFormData is in a common place
import { convertJsonToFormData } from '../commonfunctions';

export const getParties = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/parties', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Includes parties and party_numbering
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const fetchParty = async (partyId, callback) => {
    try {
        const response = await risapi.get(`/api/parties/${partyId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Includes party and party_numbering
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

export const createParty = async (newPartyData, callback) => {
    // newPartyData should include 'addresses' array
    try {
        // Use JSON for nested arrays/objects unless file uploads needed
        const response = await risapi.post('/api/parties', newPartyData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
         // Pass the whole error object for handleApiError in the form
         callback(error);
    }
};

export const updateParty = async (editPartyData, callback) => {
    // editPartyData should include 'addresses' array
    try {
        // Use JSON for nested arrays/objects
        const response = await risapi.put(`/api/parties/${editPartyData.id}`, editPartyData, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        // Pass the whole error object for handleApiError in the form
        callback(error);
    }
};

export const destroyParty = async (deleteParty, callback) => {
    try {
        const response = await risapi.delete(`/api/parties/${deleteParty.id}`, getAxiosConfig());
        if (response.status === 204) {
            callback({ party: deleteParty }); // Success indication
        }
    } catch (error) {
        // Let the calling component handle via Swal
        callback({ error });
    }
};


export const destroyPartiesMultiple = async (ids, callback) => {
    try {
        const sendData = {
            ids: ids,
            _method: 'delete' // Method spoofing for Laravel
        };
        // Use the same endpoint pattern as Hoas
        const response = await risapi.post('/api/parties/delete/multiple', sendData, getAxiosConfig());

        console.log("delete multiple parties response", response);

        if (response.status === 204) {
            callback({ party: ids }); // Indicate success with the IDs deleted
        }
    } catch (error) {
        // Let the calling component handle the error display (e.g., via Swal)
        // You might want more specific error handling here later
        callback({ error });
    }
};

// --- Add destroyPartiesMultiple later if needed ---